import React, { useState, useEffect } from "react";
import Nav from "./Navigation";
import { useLocation } from "react-router-dom";
import { getTokenInternal } from "./useToken";
import { useNavigate } from "react-router";

const EditMyAccount = () => {
  const [formData, setFormData] = useState({
    username: "",
    discord_name: "",
    password: "",
  });

  const [token, setToken] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();


  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch token
        const fetchedToken = await getTokenInternal();
        setToken(fetchedToken);

        // Check if there's account data in the location state (sent from the "Edit" button)
        const locationState = location.state;
        if (locationState && locationState.myself) {
          const { username, discord_name } =
            locationState.myself;
          setFormData({
            username,
            discord_name,
          });
        }

        setLoading(false);

        if (!fetchedToken) {
          navigate("/");
        }
      } catch (error) {
        console.error("Error fetching token:", error);
        setLoading(false);
      }
    };

    // Fetch data when the component mounts
    fetchData();
  }, [location.state, navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


const handleSubmit = (e) => {
  e.preventDefault();

  fetch(
    `${process.env.REACT_APP_API_HOST}/api/accounts/${encodeURIComponent(token.account.username)}`,
    {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token?.access_token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...formData }),
    }
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error("Error updating account.");
      }
      return response.json();
    })
    .then((data) => {
      setErrorMessage("");
      // Check if the username has been updated
      if (formData.username !== token.account.username) {
        // Username updated, navigate to the login page
        navigate("/login");
      } else {
        // Username not updated, navigate to the user profile page
        navigate("/myprofile");
      }
      // Optionally, reset the form or display a success message
    })
    .catch((error) => {
      console.error("Error updating account:", error);
      setErrorMessage("Error updating account. Please check your password.");
    });
};

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <div>
      <Nav />
      <div className="max-w-md mx-auto mt-8 text-white">
        <div>Fill out the information you want updated. If Username not available, You will get an Error</div>
        <form
          onSubmit={handleSubmit}
          className="bg-gray-800 p-6 rounded-md shadow-md"
        >
          <div className="mb-4">
            <label
              htmlFor="username"
              className="block text-sm font-medium text-gray-400"
            >
              Username
            </label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleInputChange}
              className="mt-1 p-2 w-full rounded-md bg-gray-700 text-white focus:outline-none focus:ring focus:border-blue-300"
            />
          </div>

          <div className="mb-4">
            <label
              htmlFor="discord_name"
              className="block text-sm font-medium text-gray-400"
            >
              Discord Name
            </label>
            <input
              type="text"
              id="discord_name"
              name="discord_name"
              value={formData.discord_name}
              onChange={handleInputChange}
              className="mt-1 p-2 w-full rounded-md bg-gray-700 text-white focus:outline-none focus:ring focus:border-blue-300"
            />
          </div>

          <div className="mb-4">
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-400"
            >
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              className="mt-1 p-2 w-full rounded-md bg-gray-700 text-white focus:outline-none focus:ring focus:border-blue-300"
            />
          </div>

          <button
            type="submit"
            className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline-blue"
          >
            Update Account
          </button>

          {errorMessage && <p className="text-red-500 mt-2">{errorMessage}</p>}
        </form>
      </div>
    </div>
  );
};

export default EditMyAccount;
